export const HandleSaveSettings = (data) => {
  return data?.markazSettings?.filter((fl) => {
    if (typeof fl.Value === "string") {
      return fl.Value.trim().length > 0;
    } else {
      if (!isNaN(fl.Value)) {
        return fl.Value;
      } else {
        return fl;
      }
    }
  });
};
